const FEATURES = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '零广告纯净观影',
    desc: '全站无任何形式的弹窗广告、插播广告或强制广告，从片头到片尾，纯粹享受每一帧画面。这是我们对千万影迷的承诺。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '不缓冲极速播放',
    desc: '全国30+分布式CDN加速节点，智能多线路切换技术，确保无论你身在何处都能享受秒加载、零卡顿的流畅观影体验。',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: '10万+海量片库',
    desc: '覆盖全球100+国家和地区的电影资源，从好莱坞大片到小众独立电影，从最新热映到经典老片，应有尽有持续更新。',
  },
  {
    id: 4,
    icon: 'ri-device-line',
    title: '全终端无缝切换',
    desc: '支持电脑、平板、手机全终端高清电影在线观看。手机端已优化触控操作，小屏也能享受沉浸式观影，进度自动同步。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择8090影院
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            四大核心优势，打造全网最纯净最高效的免费电影大全观影平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {FEATURES.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-100 rounded-xl p-6 border border-background-200/30 hover:border-primary-500/15 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-500/10 flex items-center justify-center mb-5 group-hover:bg-accent-500/15 transition-colors">
                <i className={`${feature.icon} text-accent-400 text-xl`}></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-800 mb-2.5">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}